import { render } from "./CitiesPage.vue?vue&type=template&id=01e9d912&ts=true"
import script from "./CitiesPage.vue?vue&type=script&lang=ts"
export * from "./CitiesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__